export default __webpack_public_path__ + "src/assets/icn-info-purple.46081ae1fc7ea7f989619c8c2dcf1d6e.svg";